import React from 'react';
import styles from './Loading.module.css';

interface LoadingProps {
  inline?: boolean;
  fullscreen?: boolean;
}

const LoadingDots: React.FC = () => (
  <div className={styles.dots}>
    <span className={styles.dot} />
    <span className={styles.dot} />
    <span className={styles.dot} />
    <span className={styles.dot} />
  </div>
);

const Loading: React.FC<LoadingProps> = ({ inline = false, fullscreen = false }) => {
  if (fullscreen) {
    return (
      <div
        className={`${styles['loading-container']} ${styles['loading-container-fullscreen']}`}
        role="status"
        aria-label="Carregando"
      >
        <LoadingDots />
      </div>
    );
  }

  if (inline) {
    return (
      <div
        className={`${styles['loading-container']} ${styles['loading-container-inline']}`}
        role="status"
        aria-label="Carregando"
      >
        <LoadingDots />
      </div>
    );
  }

  return (
    <div className={styles['loading-area']} role="status" aria-label="Carregando">
      <LoadingDots />
    </div>
  );
};

export default Loading;
